/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.gratitude-container{position:relative;margin:auto;padding-left:15px;padding-right:15px;padding-top:15px;z-index:100}.gratitude{padding:0px 10px 30px 10px;background:#d4edc6;border-radius:7px;text-align:center}.gratitude h1{font-size:3.5em}.gratitude a{text-decoration:underline}\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvbGVhZC1mb3JtL3N1Y2Nlc3NwYWdlL3N1Y2Nlc3NwYWdlLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvYnVpbGQvaG93bXVjaC9zcmMvYXBwL2xlYWQtZm9ybS9zdWNjZXNzcGFnZS9zdWNjZXNzcGFnZS5jb21wb25lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/ngfactory/app/lead-form/successpage/successpage.component.scss.ngstyle.ts